import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "@edx/frontend-platform/i18n";
import { Form, Dropdown } from "@openedx/paragon";

import SectionSubHeader from "../../generic/section-sub-header";
import messages from "./messages";

const courseTypes = [
  { label: "-", value: "" },
  { label: "FETP Course", value: "long" },
  { label: "Short Course", value: "emodule" },
  { label: "Frontline Course", value: "frontline" },
];

const durationOptions = [
  { label: "-", value: 0 },
  { label: "3 Months", value: 3 },
  { label: "6 Months", value: 6 },
  { label: "1 Year", value: 12 },
  { label: "1.5 Year", value: 18 },
  { label: "2 Year", value: 24 },
  { label: "2.5 Year", value: 30 },
  { label: "3 Year", value: 36 },
];

const DetailsSection = ({
  language,
  languageOptions,
  couresData,
  courseType,
  courseDuration,
  onChange,
}) => {
  const intl = useIntl();
  const formattedLanguage = () => {
    const result = languageOptions.find((arr) => arr[0] === language);
    return result ? result[1] : intl.formatMessage(messages.dropdownEmpty);
  };

  const formattedCourse = () => {
    const value = courseType || couresData?.courseType;
    return courseTypes.find((item) => item.value === value)?.label || "-";
  };

  const formattedDuration = () => {
    const value = courseDuration || couresData?.duration;
    return (
      durationOptions.find((item) => Number(item.value) === Number(value))
        ?.label || "-"
    );
  };

  return (
    <section className="section-container details-section">
      <SectionSubHeader
        title={intl.formatMessage(messages.detailsTitle)}
        description={intl.formatMessage(messages.detailsDescription)}
      />
      <Form.Group className="form-group-custom dropdown-language">
        <Form.Label>{intl.formatMessage(messages.dropdownLabel)}</Form.Label>
        <Dropdown className="bg-white">
          <Dropdown.Toggle variant="outline-primary" id="languageDropdown">
            {formattedLanguage()}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {languageOptions.map((option) => (
              <Dropdown.Item
                key={option[0]}
                onClick={() => onChange(option[0], "language")}>
                {option[1]}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        <Form.Control.Feedback>
          {intl.formatMessage(messages.dropdownHelpText)}
        </Form.Control.Feedback>
        <Form.Label>
          {intl.formatMessage(messages.dropdownLabelForCourse)}
        </Form.Label>

        <Dropdown className="bg-white">
          <Dropdown.Toggle variant="outline-primary" id="courseDropdown">
            {formattedCourse()}
          </Dropdown.Toggle>

          <Dropdown.Menu className="courseDropdown">
            {courseTypes.map((item) => (
              <Dropdown.Item
                key={item.value}
                onClick={() => onChange(item.value, "courseType")}>
                {item.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        <Form.Control.Feedback>
          {intl.formatMessage(messages.dropdownHelpTextForCourse)}
        </Form.Control.Feedback>
        <Form.Label>
          {intl.formatMessage(messages.dropdownLabelForCourseDuration)}
        </Form.Label>

        <Dropdown className="bg-white">
          <Dropdown.Toggle variant="outline-primary" id="durationDropdown">
            {formattedDuration()}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {durationOptions.map((item) => (
              <Dropdown.Item
                key={item.value}
                onClick={() => onChange(item.value, "courseDuration")}>
                {item.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        <Form.Control.Feedback>
          {intl.formatMessage(messages.dropdownHelpTextForCourseDuration)}
        </Form.Control.Feedback>
      </Form.Group>
    </section>
  );
};

DetailsSection.defaultProps = {
  language: "",
};

DetailsSection.propTypes = {
  language: PropTypes.string,
  languageOptions: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  ).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default DetailsSection;
